if (!customElements.get("product-gallery-modal")) {
  customElements.define(
    "product-gallery-modal",
    class ProductGalleryModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector("slider-component");
        this.tip = this.querySelector(".modal-tip");
      }

      show(opener) {
        super.show(opener);
        setTimeout(() => {
          // 弹窗可见后再同步分组并重建轮播，隐藏状态下无法测量幻灯片尺寸
          if (this.syncMediaGroup() && this.slider) this.slider.reInstall();
          this.showActiveMedia();
        }, 50);

        // 显示操作提示
        if (this.timer) clearTimeout(this.timer);
        this.tip.classList.add("active");
        this.timer = setTimeout(() => {
          this.tip.classList.remove("active");
        }, 5000);
      }

      /**
       * 同步当前变体所属的媒体分组，隐藏其它变体的媒体
       * @returns {boolean} 是否启用了分组
       */
      syncMediaGroup() {
        const groupElements = this.querySelectorAll("[data-media-group]");
        if (!groupElements.length) return false;

        const gallery = document.getElementById(
          `Media-Gallery-${this.dataset.section}`,
        );
        const groupName = gallery
          ? gallery.currentMediaGroup
          : this.dataset.currentMediaGroup || null;

        // 当前分组没有对应媒体时（例如该颜色未配图），展示全部媒体
        const showAll = !Array.from(groupElements).some(
          (element) => element.getAttribute("data-media-group") === groupName,
        );

        groupElements.forEach((element) =>
          element.classList.toggle(
            "is-current-variant-media-group",
            showAll ||
              (groupName != null &&
                element.getAttribute("data-media-group") === groupName),
          ),
        );

        return true;
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        if (!mediaId) return;

        if (this.slider && this.slider.initSliderStatus) {
          const currentSlideElement = this.slider.querySelector(
            `.slider-slide[data-media-id='${mediaId}']`,
          );
          if (!currentSlideElement) return;

          this.slider.slideByElement(currentSlideElement);

          const deferredMedia =
            currentSlideElement.querySelector(".deferred-media");
          if (deferredMedia) {
            deferredMedia.loadContent();
          }
        }
      }
    },
  );
}
